__turbopack_context__.v({
  "BigLink": "Cta2Column-module-sass-module__-KXHja__BigLink",
  "BigLinkCarousel": "Cta2Column-module-sass-module__-KXHja__BigLinkCarousel",
  "BigLinkContent": "Cta2Column-module-sass-module__-KXHja__BigLinkContent",
  "BigLinkCopy": "Cta2Column-module-sass-module__-KXHja__BigLinkCopy",
  "BigLinkImage": "Cta2Column-module-sass-module__-KXHja__BigLinkImage",
  "Cont": "Cta2Column-module-sass-module__-KXHja__Cont",
  "Cta2Column": "Cta2Column-module-sass-module__-KXHja__Cta2Column",
  "Info": "Cta2Column-module-sass-module__-KXHja__Info",
  "LargeVideo": "Cta2Column-module-sass-module__-KXHja__LargeVideo",
  "Light": "Cta2Column-module-sass-module__-KXHja__Light",
  "Main": "Cta2Column-module-sass-module__-KXHja__Main",
  "Simple": "Cta2Column-module-sass-module__-KXHja__Simple",
  "Slider": "Cta2Column-module-sass-module__-KXHja__Slider",
  "Testimonial": "Cta2Column-module-sass-module__-KXHja__Testimonial",
  "Video": "Cta2Column-module-sass-module__-KXHja__Video",
  "VideoSection": "Cta2Column-module-sass-module__-KXHja__VideoSection",
});
